
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";

  function containsMarkdown(text) {
    const markdownPatterns = [
      [/(\*\*|__)(.*?)\1/g, "$2"], // Bold (keep content)
      [/(\*|_)(.*?)\1/g, "$2"], // Italic (keep content)
      [/(\s|^)(#{1,6}\s)/g, ""], // Headers
      [/\[(.*?)\]\((.*?)\)/g, "$1"], // Links (keep the text only)
    ];

    function processLine(line) {
      markdownPatterns.forEach(([pattern, replacement]) => {
        line = line.replace(pattern, replacement);
      });
      return line;
    }

    return text.split(/\r?\n/).map(processLine).join("\n");
  }


export const convertToPdf = (data) => {
  console.log("data", data);
  let counter = 0;

  const parseHtml = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp;
  };

  const content = data.map((entry) => {
    const tmp = parseHtml(entry.message);
    const lines = [];

    tmp.childNodes.forEach((node) => {
      if (node.nodeName === "P") {
        const paragraphLines = node.textContent.split('\n');
        paragraphLines.forEach(line => {
          const trimmedLine = line.trim();
          if (trimmedLine) {
            // Process markdown and convert hyphens to bullets
            const processedLine = containsMarkdown(trimmedLine.startsWith("- ") ? 
              `• ${trimmedLine.substring(2)}` : 
              trimmedLine);
            lines.push(processedLine);
          }
        });
      } else if (node.nodeName === "UL") {
        lines.push(""); // Blank line before bullet group
        node.querySelectorAll("li").forEach((li) => {
          const indent = li.classList.contains("ql-indent-1") ? "  " : "";
          lines.push(`${indent}• ${containsMarkdown(li.textContent.trim())}`);
        });
      } else if (node.nodeName === "OL") {
        lines.push(""); // Blank line before number group
        let i = 1;
        node.querySelectorAll("li").forEach((li) => {
          const indent = li.classList.contains("ql-indent-1") ? "  " : "";
          lines.push(`${indent}${i}. ${containsMarkdown(li.textContent.trim())}`);
          i++;
        });
      } else {
        const textLines = node.textContent.split('\n');
        textLines.forEach(line => {
          const trimmedLine = line.trim();
          if (trimmedLine) {
            // Process markdown and convert hyphens to bullets
            const processedLine = containsMarkdown(trimmedLine.startsWith("- ") ? 
              `• ${trimmedLine.substring(2)}` : 
              trimmedLine);
            lines.push(processedLine);
          }
        });
      }
    });

    let textBlock = lines.join("\n");
    textBlock = textBlock.replace(/(?<!\n)\n?(\d+\.\s)/g, "\n$1");

    if (entry.user === "user") {
      counter++;
      return `${counter}) ${textBlock}`;
    }
    return textBlock;
  });

  const styles = StyleSheet.create({
    page: {
      padding: 30,
      backgroundColor: "#FFFFFF",
    },
    paragraph: {
      fontSize: 12,
      marginBottom: 10,
      lineHeight: 1.4,
    },
    listItem: {
      fontSize: 12,
      marginLeft: 15,
      marginBottom: 5,
      flexDirection: "row",
    },
    bullet: {
      width: 10,
    },
    listContent: {
      flex: 1,
    },
    listLine: {
      marginLeft: 10,
    },
    textLine: {
      marginBottom: 4,
      display: 'block'
    }
  });

//   setShowPdfLink(true);

  const renderTextWithBreaks = (text) => {
    return text.split('\n').map((line, i) => (
      <Text key={i} style={styles.textLine}>
        {line}
      </Text>
    ));
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View>
          {content.map((text, index) => {
            return text.split(/\n{2,}/).map((paragraph, paraIndex) => {
              if (paragraph.includes("•") || paragraph.includes("- ")) {
                return paragraph.split("\n").map((line, lineIndex) => {
                  if (line.trim().startsWith("•") || 
                      line.trim().startsWith("-") || 
                      line.trim().startsWith("  •") || 
                      line.trim().startsWith("  -")) {
                    const isIndented = line.trim().startsWith("  ");
                    const content = containsMarkdown(line.replace(/^\s*[•-]\s*/, ""));
                    return (
                      <View
                        key={`${index}-${paraIndex}-${lineIndex}`}
                        style={[
                          styles.listItem,
                          isIndented && { marginLeft: 25 },
                        ]}
                      >
                        <Text style={styles.bullet}>•</Text>
                        <Text style={styles.listContent}>
                          {renderTextWithBreaks(content)}
                        </Text>
                      </View>
                    );
                  }
                  return (
                    <View key={`${index}-${paraIndex}-${lineIndex}`} style={styles.paragraph}>
                      {renderTextWithBreaks(containsMarkdown(line))}
                    </View>
                  );
                });
              }
              return (
                <View key={`${index}-${paraIndex}`} style={styles.paragraph}>
                  {renderTextWithBreaks(containsMarkdown(paragraph))}
                </View>
              );
            });
          })}
        </View>
      </Page>
    </Document>
  );
};